import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4953571f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scan-qrcode-wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-text" }, "请使用手机微信扫描二维码访问", -1))
const _hoisted_3 = { class: "scan-qrcode" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

import { Popup, Picker } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { isXagarApp } from '@/utils/app'
import { usePlatformInfo } from '@/compositions/common'
import { ref, Ref, ComputedRef, computed, onMounted, onActivated } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import AppHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import FaultOrderListWrap from './components/fault-order-list-wrap.vue'
import normalDeviceORderListQrcode from '@/assets/service/page-device-order-list-qrcode.png'
import carDeviceORderListQrcode from '@/assets/service/page-device-order-list-qrcode-car.png'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'malfunction-repair-order-list',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const show: Ref<boolean> = ref(false)
const { isLandscape, isSrc4Device } = usePlatformInfo()
const billType: Ref<string> = ref('')
const $route = useRoute()
const $router = useRouter()

const fromOneClickSubmit = computed(() => {
  return $route.query.from === 'oneClickSubmit'
})

const { addFaultOrderListItemKeepAlive, removeNetworkListKeepAlive } = useMalfunctionRepairStore()
const columnObjs: { type: string; name: string }[] = [
  {
    type: '',
    name: '全部',
  },
  {
    type: 'WAIT_RECEIVE',
    name: '待接单',
  },
  {
    type: 'HANDLE_ING',
    name: '维修中',
  },
  {
    type: 'END',
    name: '已完成',
  },
  {
    type: 'CANCEL',
    name: '已取消',
  },
]
const columns = columnObjs.map((it) => it.name)
const qrcodeUrl = computed(() => {
  return isXagarApp ? carDeviceORderListQrcode : normalDeviceORderListQrcode
})
const typeName: ComputedRef<string> = computed(() => {
  const obj = columnObjs.find((it) => it.type === billType.value)
  return obj?.name || '全部'
})
const onConfirm = (value: string, index: number) => {
  billType.value = columnObjs[index].type
  show.value = false
}
const onCancel = () => {
  show.value = false
}
const themeVars: { pickerConfirmActionColor: string } = {
  pickerConfirmActionColor: '#07c160',
}

function leftClickHandle() {
  if (fromOneClickSubmit.value) {
    AppHost.goAppBack()
    return
  }
  $router.go(-1)
}
onMounted(() => {
  addFaultOrderListItemKeepAlive()
  removeNetworkListKeepAlive()
})
onActivated(() => {
  removeNetworkListKeepAlive()
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_config_provider = _resolveComponent("van-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "售后服务记录",
      isReturnLeftEvent: "",
      onLeftClick: leftClickHandle
    }),
    (_unref(isSrc4Device))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "qrcode-img",
              src: _unref(qrcodeUrl),
              alt: "售后服务记录"
            }, null, 8, _hoisted_4)
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
            }, [
              _createTextVNode(_toDisplayString(_unref(typeName)), 1),
              _createVNode(_component_van_icon, { name: "arrow-down" })
            ])
          ]),
          _createVNode(FaultOrderListWrap, {
            class: "xag-container",
            billType: billType.value
          }, null, 8, ["billType"])
        ], 64)),
    _hoisted_6,
    _createVNode(_unref(Popup), {
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      position: "bottom",
      "safe-area-inset-bottom": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_config_provider, { "theme-vars": themeVars }, {
          default: _withCtx(() => [
            _createVNode(_unref(Picker), {
              title: "单据类型",
              columns: _unref(columns),
              onConfirm: onConfirm,
              onCancel: onCancel
            }, null, 8, ["columns"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})